(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elle-bundle-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bundle-popup]').forEach((popup) => {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const closePopup = () => {
      popup.close();
    };

    popup.querySelector('[data-popup-close]')?.addEventListener('click', closePopup);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });

    window.setTimeout(() => {
      if (!popup.open) popup.showModal();
    }, Number(popup.dataset.delay));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elle-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elle-carousel')) {
    customElements.define('elle-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.elle-carousel__track');
        this.slides = [...this.querySelectorAll('.elle-carousel__slide')];
        if (!this.slides.length) return;
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.abort = new AbortController();
        const listen = (el, event, fn) => el.addEventListener(event, fn, {signal: this.abort.signal});
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.reduced;
        this.hovered = false;
        this.focused = false;
        listen(this.querySelector('[data-next]'), 'click', () => this.step(1));
        listen(this.querySelector('[data-prev]'), 'click', () => this.step(-1));
        this.dots.forEach(dot => listen(dot, 'click', () => this.go(Number(dot.dataset.index))));
        listen(this.track, 'scroll', () => this.update());
        listen(this.track, 'keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        listen(this, 'mouseenter', () => {this.hovered = true; this.schedule();});
        listen(this, 'mouseleave', () => {this.hovered = false; this.schedule();});
        listen(this, 'focusin', () => {this.focused = true; this.schedule();});
        listen(this, 'focusout', event => {if (!this.contains(event.relatedTarget)) {this.focused = false; this.schedule();}});
        listen(document, 'visibilitychange', () => this.schedule());
        listen(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) {this.userPaused = true; this.go(index); this.schedule();}
        });
        this.pause = this.querySelector('[data-pause]');
        if (this.pause) listen(this.pause, 'click', () => {this.userPaused = !this.userPaused; this.schedule();});
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.intersection = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting; this.schedule();});
        this.intersection.observe(this);
        this.update();
      }
      positions() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const start = this.slides[0].offsetLeft;
        return this.slides.map(slide => Math.min(max, slide.offsetLeft - start));
      }
      update() {
        const positions = this.positions();
        const pages = positions.filter((pos, index) => index === 0 || Math.abs(pos - positions[index - 1]) > 2);
        this.pages = pages;
        this.active = pages.reduce((best, pos, index) => Math.abs(pos - this.track.scrollLeft) < Math.abs(pages[best] - this.track.scrollLeft) ? index : best, 0);
        this.querySelector('.elle-carousel__controls').hidden = pages.length < 2;
        this.dots.forEach((dot, index) => {dot.hidden = index >= pages.length; dot.setAttribute('aria-current', String(index === this.active));});
      }
      go(index) {
        const positions = this.positions();
        this.track.scrollTo({left: positions[index] || 0, behavior: this.reduced ? 'auto' : 'smooth'});
      }
      step(direction) {
        this.update();
        const target = (this.active + direction + this.pages.length) % this.pages.length;
        this.track.scrollTo({left: this.pages[target], behavior: this.reduced ? 'auto' : 'smooth'});
      }
      schedule() {
        clearInterval(this.timer);
        if (this.pause) {this.pause.setAttribute('aria-pressed', String(this.userPaused)); this.pause.textContent = this.userPaused ? '▶' : 'Ⅱ';}
        if (this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.focused || !this.visible || document.hidden || window.Shopify?.designMode) return;
        this.timer = setInterval(() => this.step(1), Number(this.dataset.delay) || 5000);
      }
      disconnectedCallback() {
        clearInterval(this.timer); this.abort?.abort(); this.resize?.disconnect(); this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
